exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".verbPadding{margin-top:1vh}.verbPadding .textlink{color:#f1f1f1;text-decoration:underline;font-weight:300;font-size:1.8vw}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/landingpage/optimumidslanding/optimumidslanding.scss
// module id = 89
// module chunks = 0